import React, { useEffect } from 'react';
import Article from "./Article6.png";
import { Container } from '@mui/material';

const headingStyle = {
  fontFamily: 'Inter',
  fontWeight: 500,
  fontSize: '16px',
  color: '#221F1F',
  lineHeight: '36px',
};

const titleStyle = {
  fontFamily: 'Inter',
  fontWeight: 700,
  fontSize: '32px',
  color: '#31B9B5',
  lineHeight: '53.25px',
};

const paragraphStyle = {
  fontFamily: 'DM Sans',
  fontWeight: 400,
  fontSize: '16px',
  color: '#222222BF',
  lineHeight: '40.73px',
  textAlign: 'justify',
};

const ArticlePage6 = () => {
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Container maxWidth="xl" className="articleContainer">
      <div>
        <img src={Article} alt="Article 2" style={{  maxWidth: '100%', height: 'auto', marginTop: '50px' }} />
      </div>

      <div>
      <header>
        <h1 style={titleStyle}>Addressing Queries and Concerns on Mortgage Loans</h1>
      </header>

      <article>
        <h2 style={headingStyle}>Introduction</h2>
        <p style={paragraphStyle}>The process of securing a mortgage loan can be complex and often raises numerous questions and concerns. In this article, we aim to address some common queries and concerns related to mortgage loans, providing a clearer understanding of the process and empowering potential homebuyers to make informed decisions.</p>

        <h2 style={headingStyle}>1. What is a mortgage loan?</h2>
        <p style={paragraphStyle}>A mortgage loan is a financial product that allows individuals or families to borrow money from a lender...</p>

        <h2 style={headingStyle}>2. How do I qualify for a mortgage loan?</h2>
        <p style={paragraphStyle}>To qualify for a mortgage loan, lenders typically assess several factors, including credit score, income...</p>

        <h2 style={headingStyle}>3. What types of mortgage loans are available?</h2>
        <p style={paragraphStyle}>There are various types of mortgage loans available in the USA, including conventional loans...</p>

        <h2 style={headingStyle}>4. What is the down payment requirement?</h2>
        <p style={paragraphStyle}>The down payment requirement varies depending on the loan type and lender...</p>

        <h2 style={headingStyle}>5. How does the interest rate affect my mortgage?</h2>
        <p style={paragraphStyle}>The interest rate on your mortgage loan significantly impacts your monthly payments...</p>

        <h2 style={headingStyle}>6. What are closing costs?</h2>
        <p style={paragraphStyle}>Closing costs are fees and expenses associated with finalizing the mortgage loan...</p>

        <h2 style={headingStyle}>7. What is mortgage insurance?</h2>
        <p style={paragraphStyle}>Mortgage insurance is a policy that protects the lender in case the borrower defaults on the loan...</p>

        <h2 style={headingStyle}>Conclusion</h2>
        <p style={paragraphStyle}>Navigating the mortgage loan process can be overwhelming, but understanding the basics and seeking guidance from professionals can alleviate concerns...</p>
      </article>
    </div>
    </Container>
   
  );
};

export default ArticlePage6;
